import { AGENT_API_URL, AGENT_API_URL_DEV } from "@/app/config";
// 根据域名判断使用哪个API URL
export const getApiUrl = (): string => {
  // 在客户端环境下获取当前域名
  if (typeof window !== "undefined") {
    const currentDomain = window.location.origin;
    // 如果是 https://fellou.ai 则使用生产环境API
    if (currentDomain === "https://fellou.ai") {
      return AGENT_API_URL;
    }
  }
  // 其他情况使用开发环境API
  return AGENT_API_URL_DEV;
};
